export default class Publication{
	id:string;
	title:string;
	text:string;
	pdf:any;
	image:any;
	date:any;
}